import React, { useState } from "react";
import { Modal } from "antd";
import AddFunds from "./AddFunds";
import AccountModal from "./AccountModal";
import AddBank from "./AddBank"

const Funds = ({ myBounty }) => {
  const [setModal, setModalVisible] = useState(false);
  const [setModal2, setModalVisible2] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showWithdrawModal = () => {
    setModalVisible(true);
  };
  const handleWithdraw = () => {
    setModalVisible(false);
  };
  const cancelWithdraw = () => {
    setModalVisible(false);
  };
  const showAddFundsModal = () => {
    setModalVisible2(true);
  };
  const handleAddFunds = () => {
    setModalVisible2(false);
  };
  const cancelAddfunds = () => {
    setModalVisible2(false);
  };
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <div className="bounty-card-wrapper account-balance">
      <Modal
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        closable={false}
        className="modal-body"
      >
        <AddBank
          handleCancel={() => {
            setIsModalVisible(false);
          }}
        />
      </Modal>
      <div className="form-detailss">
        <div>
          <div className="input-fieldd">
            <p className="para">Account Balance</p>
            <input type="text" placeholder="$250" className="text" />
          </div>
          <div className="input-fieldd">
            <p className="para">Withdrawal method</p>
            <div className="logo-box">
              <input type="text" />
              <span className="pr-2" onClick={showModal}> Add bank account </span>
            </div>
          </div>
        </div>
        <div className="row d-flex signup-with mt-4">
          <div className="col-6">
            <button className="cancel" onClick={showAddFundsModal}>
              Add funds
            </button>
          </div>
          <div className="col-6">
            <button className="intro" onClick={showWithdrawModal}>
              Withdraw funds
            </button>
          </div>
        </div>
      </div>

      <Modal
        visible={setModal}
        onOk={handleWithdraw}
        onCancel={cancelWithdraw}
        footer={null}
        closable={false}
        className="modal-body"
      >
        <AccountModal handleCancel={() => {
            setModalVisible(false);
          }}/>
      </Modal>
      <Modal
        visible={setModal2}
        onOk={handleAddFunds}
        onCancel={cancelAddfunds}
        footer={null}
        closable={false}
        className="modal-body"
      >
        <AddFunds handleCancel={() => {
            setModalVisible2(false);
          }}/>
      </Modal>
    </div>
  );
};

export default Funds;